import { combineReducers } from 'redux'

import * as AllReducers from './reducers'

export default combineReducers(AllReducers)